var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-input-color-group"},[_c('i',{staticClass:"custom-input-color-icon"}),_vm._v(" "),_c('input',_vm._g(_vm._b({staticClass:"form-control",attrs:{"data-testid":_vm.testid},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),_vm.inputListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }